<div class="compare-table-control">
    <wuc-compare-table-coverage
        [selectedColumnKey]="selectedCoverageId"
        [data]="data"
        [isMobileView]="
            ((isScreenMedium$ | async) && group.coverages.items.length >= 6) ||
            (isScreenMedium$ | async) ||
            !(isScreenLarge$ | async)
        "
        tableBackgroundColor="light"
        dataColumnBackgroundColor="dark"
        labelColumnBackgroundColor="light"
        [hasCursorPointer]="true"
        [isHoverBorderVisible]="true"
        (clicked)="onClicked($event)"
    ></wuc-compare-table-coverage>
</div>
